import { css } from 'lit-element';

export const kwCarouselInteractiveStyles = css`
  :host {
    display: block;
    width: 100%;
    --color-primary-default: var(--color-primary, #FF7900);
    --margin-top: var(--header-desktop-height, 60px);
    --carousel-max-height: 572px;
    --carousel-list-wrapper-left: 0;
  }

  .kw-carousel-interactive__items-container {
    max-height: var(--carousel-max-height);
    width: 100%;
    overflow: hidden;
  }

  .kw-carousel-interactive ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .kw-carousel-interactive__items-list-wrapper {
    position: relative;
    transition: left 0.8s ease 0s;
    overflow: hidden;
  }

  .kw-carousel-interactive__items-list {
    display: flex;
    position: absolute;
    overflow: hidden;
    transition: left 0.8s ease 0s;
    left: 0;
  }

  .kw-carousel-interactive__buttons-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: var(--margin-top);
  }

  .kw-carousel-interactive__buttons-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 326px;
    margin-top: -12rem;
    z-index: 2;
  }

  .kw-carousel-interactive__arrow-container {
    display: flex;
    align-items: center;
    width: 2.5rem;
    height: 2.5rem;
  }

  .kw-carousel-interactive__arrow-container:focus-within {
    outline: 1px solid var(--color-primary-default);
  }

  .kw-carousel-interactive__arrow {
    border: 0;
    padding: 0;
    margin: 0;
    background-image: url("/assets/images/arrow_left.svg");
    background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
  }

  .kw-carousel-interactive__arrow:hover:not(:disabled) {
    background-image: url("/assets/images/arrow_left--hover.svg");
    cursor: pointer;
  }

  .kw-carousel-interactive__arrow:disabled {
    opacity: 0.4;
  }

  .kw-carousel-interactive__arrow:focus {
    outline: 0px;
  }

  .kw-carousel-interactive__arrow--right {
    transform: rotate(-180deg);
  }

  .kw-carousel-interactive__dots-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 25%;
  }

  .kw-carousel-interactive__dot {
    background-color: #b8b8b8;
    border-radius: 50%;
    border: none;
    display: inline-block;
    padding: 0;
    margin: 0;
    height: 8px;
    width: 8px;
  }

  .kw-carousel-interactive__dot:hover,
  .kw-carousel-interactive__dot[selected] {
    background-color: var(--color-primary-default);
    cursor: pointer;
    outline: none;
    height: 12px;
    width: 12px;
  }

  /* Not displayed in mobile  */
  @media all and (max-width: 767px) {
    :host {
      display: none;
    }
  }

  @media all and (min-width: 1024px) {
    .kw-carousel-interactive__buttons-container {
    margin-top: 0;
  }
  }
`;
